import { render, staticRenderFns } from "./SgWireServices.vue?vue&type=template&id=a0de309e&"
import script from "./SgWireServices.vue?vue&type=script&lang=js&"
export * from "./SgWireServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports